"use client";import{jsxs as e,jsx as r}from"react/jsx-runtime";import{forwardRef as t,useState as o,useEffect as n,useCallback as c}from"react";import"tailwind-merge";import{Box as s}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import{CheckboxButton as a}from"./Checkbox.parts.js";function i(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}function l(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{},o=Object.keys(t);"function"==typeof Object.getOwnPropertySymbols&&(o=o.concat(Object.getOwnPropertySymbols(t).filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})))),o.forEach((function(r){i(e,r,t[r])}))}return e}function u(e,r){if(null==e)return{};var t,o,n=function(e,r){if(null==e)return{};var t,o,n={},c=Object.keys(e);for(o=0;o<c.length;o++)t=c[o],r.indexOf(t)>=0||(n[t]=e[t]);return n}
/**
 * @component
 * @param {Object} props - 체크박스 컴포넌트 프로퍼티
 * @param {boolean} [props.checked=false] - 체크박스의 체크 상태
 * @param {(event: ChangeEvent<HTMLInputElement>) => void} [props.onChange] - 체크박스 상태 변경 시 호출되는 콜백 함수
 * @param {boolean} [props.disabled=false] - 체크박스 비활성화 여부
 * @param {boolean} [props.isError=false] - 체크박스 에러 상태 여부
 * @param {'box' | 'circle' | 'sub'} [props.type='box'] - 체크박스 타입
 * @param {string} [props.className] - 추가 CSS 클래스
 *
 * @example
 * // 기본 사용법
 * <Checkbox checked={isChecked} onChange={handleChange} />
 *
 * // 비활성화된 체크박스
 * <Checkbox disabled />
 *
 * // 에러 상태의 체크박스
 * <Checkbox isError />
 *
 * // 커스텀 스타일이 적용된 체크박스
 * <Checkbox className="custom-checkbox" />
 *
 * // 체크박스 상태 변경 핸들링
 * const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
 *   console.log('체크박스 상태:', e.target.checked);
 * };
 * <Checkbox onChange={handleChange} />
 */(e,r);if(Object.getOwnPropertySymbols){var c=Object.getOwnPropertySymbols(e);for(o=0;o<c.length;o++)t=c[o],r.indexOf(t)>=0||Object.prototype.propertyIsEnumerable.call(e,t)&&(n[t]=e[t])}return n}const p=/*#__PURE__*/t(((t,i)=>{var{checked:p=!1,onChange:b,disabled:f=!1,isError:d=!1,type:m="box",className:y}=t,h=u(t,["checked","onChange","disabled","isError","type","className"]);const[g,O]=o(p),[j,k]=o(!1);n((()=>{O(p)}),[p]);const x=c((e=>{f||b&&(b(e),O(e.target.checked),e.target.checked||k(!1))}),[b,f]);/*#__PURE__*/
return e(s,{"data-testid":"design-system-checkbox",className:"group relative flex size-fit",children:[
/*#__PURE__*/r("input",l({ref:i,className:"absolute inset-0 z-10 cursor-pointer opacity-0",type:"checkbox",checked:g,onChange:x,onFocus:()=>{k(!0)},onBlur:()=>{k(!1)},disabled:f},h)),
/*#__PURE__*/r(a,{checked:g,disabled:f,isError:d,isFocused:j,type:m,className:y})]})}));p.displayName="Checkbox";export{p as Checkbox};
